import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faEye } from '@fortawesome/free-solid-svg-icons';
import '../../styles/AdminDataTable.css';

const BlogPostsTable = ({ 
  posts, 
  selectedPosts, 
  onSelectPost, 
  onSelectAll, 
  onEdit, 
  onDelete, 
  onView 
}) => {
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const truncateText = (text, maxLength = 45) => {
    if (!text || text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      draft: { class: 'blog-status-draft', text: 'Draft' },
      published: { class: 'blog-status-published', text: 'Published' }
    };
    
    const config = statusConfig[status] || statusConfig.draft;
    return <span className={`status-badge ${config.class}`}>{config.text}</span>;
  };

  const getCategoryBadge = (category) => {
    if (!category) return <span className="blog-category-badge no-category">No Category</span>;
    return <span className="blog-category-badge">{category.name}</span>;
  };

  return (
    <div className="admin-data-table__container">
      <table className="admin-data-table">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                checked={selectedPosts.length === posts.length && posts.length > 0}
                onChange={(e) => onSelectAll(e.target.checked)}
              />
            </th>
            <th>ID</th>
            <th>Title</th>
            <th>Category</th>
            <th>Status</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {posts.map((post) => (
            <tr key={post.id}>
              <td>
                <input
                  type="checkbox"
                  checked={selectedPosts.includes(post.id)}
                  onChange={(e) => onSelectPost(post.id, e.target.checked)}
                />
              </td>
              <td>{post.id}</td>
              <td>
                <div className="blog-post-title-cell">
                  <div className="blog-post-title" title={post.title}>
                    {truncateText(post.title)}
                  </div>
                  
                </div>
              </td>
              <td>{getCategoryBadge(post.category)}</td>
              <td>{getStatusBadge(post.status)}</td>
              <td>{formatDate(post.created_at)}</td>
              <td>
                <div className="action-buttons">
                  <button
                    className="button secondary"
                    onClick={() => onView(post)}
                    title="View Post"
                  >
                    <FontAwesomeIcon icon={faEye} />
                  </button>
                  <button
                    className="button secondary"
                    onClick={() => onEdit(post)}
                    title="Edit Post"
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                  <button
                    className="button secondary"
                    onClick={() => onDelete(post)}
                    title="Delete Post"
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      
      {posts.length === 0 && (
        <div className="blog-no-data">
          <p>No blog posts found</p>
        </div>
      )}
    </div>
  );
};

export default BlogPostsTable; 